import { Injectable, WritableSignal, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  state: WritableSignal<boolean> = signal(false);
  heading: string = '';
  filterDrawerStateChanged$ = new Subject<boolean>();
  constructor() {}

  openFilter() {
    this.state.set(true);
    this.heading = 'Filter(s)';
    this.filterDrawerStateChanged$.next(true);
  }
  closeFilter() {
    this.state.set(false);
    this.filterDrawerStateChanged$.next(false);
  }
}
